import { Switch } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

type TSwitchTheme = { checked: boolean; toggleTheme: () => void };

const SwitchTheme = ({ checked, toggleTheme }: TSwitchTheme) => (
  <Switch
    aria-label="Theme toggler"
    checked={checked}
    onChange={toggleTheme}
    data-testid="theme-toggler"
    size="lg"
    thumbLabel={{
      on: <Icon name={iconNames.sun} fill="black" width="16px" height="16px" />,
      off: (
        <Icon name={iconNames.moon} fill="black" width="16px" height="16px" />
      ),
    }}
  ></Switch>
);

export default SwitchTheme;
